import { Injectable, inject } from '@angular/core';
import { WINDOW } from '@campus/browser';
import { ENVIRONMENT_LOGIN_TOKEN } from '@campus/environment';
import { PersonInterface } from '@campus/public-portal';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  private environment = inject(ENVIRONMENT_LOGIN_TOKEN);
  private window = inject(WINDOW);

  public toPlatform(user: PersonInterface) {
    if (!user) return;

    const type = user.types?.[0] || 'teacher';
    const url = this.getPlatformUrl(type);

    if (url) this.redirect(url);
  }

  public getPlatformUrl(type: string) {
    return this.environment[`${type}AppUrl`] || this.environment.teacherAppUrl;
  }

  public redirect(url: string) {
    this.window.location.assign(url);
  }
}
